export function nullRemover(params: Object): any {
if (params) {
  Object.keys(params).forEach(k => ((params[k] == null || params[k] === '' || params[k] == undefined || params[k] == 'undefined')) && delete params[k]);
  return params;
}
}
export function isEmpty(value: String): any {
  return value === '' || value === undefined || value === null;
}
